<template>
    <Modal ref="modal" class="cancel-recurrent-order-modal" @closed="onModalClose">
        <template #header="sp">
            <div class="h3">Supprimer la commande récurrente</div>
        </template>
        <template #body="sp">
            <div class="form-group row">
                <label for="staticCustomerName" class="col-4 col-form-label">Client</label>
                <div class="col-8">
                    <input type="text" readonly class="form-control-plaintext" id="staticCustomerName" :value="order.customer.name">
                </div>
            </div>

            <div class="form-group row">
                <label for="staticDeliveryDate" class="col-4 col-form-label">Date de livraison</label>
                <div class="col-8">
                    <input type="text" readonly class="form-control-plaintext" id="staticDeliveryDate" :value="formatDate(order.delivery_date)">
                </div>
            </div>

            <div v-if="!deletionConfirmed" class="alert alert-danger">
                Il s'agit d'une commande récurrente. Si vous la supprimez le client n'aura plus sa commande créée automatiquement pour ce jour de livraison. Il devra recréer sa commande hebdomadaire.

                <button class="btn btn-danger btn-block" @click="deletionConfirmed = true">J'ai compris</button>
            </div>

            <ErrorsZone :errors="errorsDeleting" />
        </template>
        <template #footer>
            <button :disabled="!deletionConfirmed || deleting" class="btn btn-danger" @click="onClickDeleteButton()">
                <i class="fad fa-trash"></i> Supprimer la commande récurrente
            </button>
        </template>
    </Modal>
</template>

<script>
    import ErrorsZone from "./ErrorsZone";
    import Modal from "./Modal";

    import {useDeleteRequest} from "./compositions/axios/deleteRequest"

    export default {
        name: 'CancelRecurrentOrderModal',

        components: {
            ErrorsZone,
            Modal,
        },

        setup() {
            const {
                deleting,
                errorsDeleting,
                doDelete,
            } = useDeleteRequest();

            return {
                deleting,
                errorsDeleting,
                doDelete,
            };
        },

        props: {
            order: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                deletionConfirmed: false,
            };
        },

        methods: {
            showModal() {
                this.$refs.modal.showModal();
            },

            closeModal() {
                this.$refs.modal.closeModal();
            },

            formatDate(date) {
                return 'Tous les ' + moment(date).format('dddd')
            },

            onModalClose() {
                this.deletionConfirmed = false;
                this.errorsDeleting = null;
            },

            async onClickDeleteButton() {
                await this.doDelete('/espace-employes/commandes/commande-magasin-recurrente/' + this.order.id);

                if (!this.errorsDeleting) {
                    window.location = '/espace-employes/clients/' + this.order.fk_customer_id;
                }
            },
        },
    }
</script>

<style lang="scss">
    .cancel-recurrent-order-modal {
        :first-of-type(.modal-container) {
            max-width: 600px;
            width: auto;
        }
    }
</style>
